<template>
  <fieldset>
    <legend>Climatic</legend>
    <FormSelect
      :name="'Site:'"
      v-model:selected="climaticSite"
      :options="siteOptions"
      :displayOptions="siteNames"
    ></FormSelect>

    <!--Form-input v-model="climaticSite['Ss']" :name="'Ss:'" :readonly="true"></Form-input>
    <Form-input v-model="climaticSite['Sr']" :name="'Sr:'" :readonly="true"></Form-input>
    <Form-input v-model="climaticSite['q50']" :name="'q50:'" :readonly="true"></Form-input-->
    <p>Ss = {{climaticSite['Ss']}}kPa ; Sr = {{climaticSite['Sr']}}kPa ; q50 = {{climaticSite['q50']}}kPa</p>

   
    <!--div class="debug">
            <p>climaticSite = {{ climaticSite }}</p>
        </div>-->
  </fieldset>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import FormInput from './form/Form-input.vue'
import FormSelect from './form/Form-select.vue'
//import { useClimaticStore } from '@/stores';
//const climaticStore = useClimaticStore();

const siteOptions = defineModel<Array<Object>>('siteOptions', { required: true })
/*
const props = defineProps({
    siteOptions : Array
});*/
const siteNames = computed(() => {
  return siteOptions.value.map((site) => {
    return site.lookup
  })
})
const climaticSite = defineModel<Object | null>('climaticSite', { required: true })
</script>
